import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { defaultUser, User } from "src/types/user";

// ----------------------------------------------------------------------

export default function NameItem() {
	const { data: user } = useQuery<User>({ queryKey: ["user"], initialData: defaultUser });

	return (
		<Box sx={{ my: 1, px: 2 }}>
			<Typography noWrap variant='subtitle2'>
				{user?.organization?.name}
			</Typography>
			<Typography noWrap sx={{ color: "text.secondary" }} variant='body2'>
				{user?.email}
			</Typography>
		</Box>
	);
}
